import { VendorUserType } from 'auth/VendorAuth/vendorUserSlice';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useAppSelector } from 'hooks/redux';
import { HashLink } from 'react-router-hash-link';
import { selectRfi } from 'store/rfiSlice';
import { selectVendorResponse } from 'store/vendorResponseSlice';
import { RfiStatus, sectionNames } from '../../types/RfiTypes';
import QandASection from '../QandA/QandASection';
import QuestionSubmission from '../QandA/QuestionSubmission';
import { vendorNavPages } from './VendorNav';

interface IRfiVendorAllProps {
  // rfi: any;
  user?: VendorUserType;
  section?: string;
  setIsUpdateQA?: any;
  setSelectedPage: (page: number) => void;
  readOnly?: boolean;
}

const VendorRfiQandA = (props: IRfiVendorAllProps) => {
  dayjs.extend(utc);

  // Hooks
  const rfi = useAppSelector(selectRfi);
  const vendorResponse = useAppSelector(selectVendorResponse);

  // State
  let questionNumber: number = 0;

  // Functions
  const calcQaOpen = (): boolean => {
    let result = false;
    const now = dayjs.utc();

    if (rfi.rfi?.status === RfiStatus.POSTED) {
      // Check Archive Date
      if (rfi.rfi?.archiveDate) {
        const archiveDate = dayjs.utc(rfi.rfi?.archiveDate).add(1, "day");
        // Archive Date supercedes QA Close Date
        if (now < archiveDate) {
          // Check QA Close Date
          if (rfi.rfi?.qaCloseDate) {
            const qaCloseDate = dayjs.utc(rfi.rfi?.qaCloseDate);
            if (now < qaCloseDate) {
              result = true;
            }
          } else {
            result = true;
          }
        }
      }
    }

    return result;
  };
  let isQAOpen = calcQaOpen();

  // Render
  return (
    <div className="rfi-content">
      <div className="row">
        <div className="col d-flex  mb-3">
          <h1>Q&A</h1>
        </div>
        <div className="col d-flex justify-content-end mb-3">
          {props.user && props.user.isAuthenticated && isQAOpen && (
            <HashLink smooth elementId="question-submission-text" to="">
              <button
                className="btn btn-primary mb-4 me-3"
                aria-label="Scroll to Vendor QA Submission"
              >
                <span>Ask a Question</span>
              </button>
            </HashLink>
          )}
        </div>
      </div>

      <h2>RFI General Questions</h2>

      <QandASection isQAOpen={isQAOpen} {...props} />

      <h2>Questionnaire</h2>
      <QandASection
        section={sectionNames.VENDOR_INFO}
        isQAOpen={isQAOpen}
        {...props}
      />
      <QandASection
        section={sectionNames.QUESTIONNAIRE}
        isQAOpen={isQAOpen}
        {...props}
      />
      {props.user && props.user.isAuthenticated && isQAOpen && (
        <QuestionSubmission user={props.user} />
      )}
      {(props.user && !props.user.isAuthenticated) ||
      (vendorResponse.vendorResponse?.vendorResponseId ?? 0) === 0 ? (
        <button
          className="btn btn-primary m-1"
          role="button"
          onClick={() =>
            props.setSelectedPage(vendorNavPages.UNAUTH_QUESTIONNAIRE)
          }
        >
          <i className="fa-solid fa-chevron-left"></i>Questionnaire
        </button>
      ) : (
        <div>
          <button
            className="btn btn-primary m-1"
            role="button"
            onClick={() =>
              props.setSelectedPage(vendorNavPages.UNAUTH_ATTACHMENTS)
            }
          >
            <i className="fa-solid fa-chevron-left"></i> Attachments
          </button>
          <button
            className="btn btn-primary m-1"
            role="button"
            onClick={() => props.setSelectedPage(vendorNavPages.VENDOR_INFO)}
          >
            Step 1: Update Vendor Information{" "}
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default VendorRfiQandA;
